var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSortHover = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 12 10",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Sorting-Columns-/-Rows",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rules",
  transform: "translate(-54.000000, -255.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Sorting-Arrows",
  transform: "translate(48.000000, 248.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#435370",
  x: 14,
  y: 9,
  width: 2,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#435370",
  x: 8,
  y: 7,
  width: 2,
  height: 8
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#435370",
  points: "15 7 18 11 12 11"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#435370",
  transform: "translate(9.000000, 15.000000) rotate(180.000000) translate(-9.000000, -15.000000) ",
  points: "9 13 12 17 6 17"
}))))));
export default SvgSortHover;